import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormularioComponent } from '../../shared/formulario/formulario.component';
import { GlobalState } from '../../services/global-state';
import { LlamanosApiService } from '../../services/api-llamanos.service';
import { ExternalApisService } from '../../services/external-apis.service';

@Component({
  selector: 'app-siniestros',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, FormularioComponent],
  templateUrl: './siniestros.component.html',
  styleUrl: './siniestros.component.scss',
})
export class SiniestrosComponent {
  SINIESTROS = [
    {
      label: 'Accidente en estación de servicio',
      key: 'Información accidente en E/S',
      icon: 'assets/accidente.svg',
    },
    {
      label: 'Cliente se retira sin pagar',
      key: 'Cliente se retira sin pagar',
      icon: 'assets/nomoney.svg',
    },
    {
      label: 'Delito en Copec',
      key: 'Delito en Copec',
      icon: 'assets/delito.svg',
    },
    {
      label: 'Asalto en instalación',
      key: 'Asalto a instalación',
      icon: 'assets/assault.svg',
    },
    {
      label: 'Daño en vehículo por máquina de lavado',
      key: 'Daños en el vehículo por máquina de lavado',
      icon: 'assets/damage.svg',
    },
    {
      label: 'Vandalismo',
      key: 'Vandalismo',
      icon: 'assets/vandalismo.svg',
    },
  ];

  activeSiniestros: any = [];
  Object = Object;

  selectedEstacion: any = null;
  selectedEstacionComplete: {
    label: string;
    value: number;
    desde: Date;
  } | null = null;
  readonly siniestroTooltip =
    'Debes seleccionar la estación para la que deseas ingresar un siniestro';

  edsOptions: Array<{ label: string; value: number; desde: Date }> = [];
  showFormulario: boolean = false;
  selectedSiniestro: any = null;
  allSiniestros: any = {};

  isArcoprime: boolean = false;
  pagadores: Array<{ id_pagador: string; label: string }> = [];
  selectedPagador: string | null = null;

  constructor(
    private globalState: GlobalState,
    private api: LlamanosApiService,
    private externalApis: ExternalApisService,
  ) {}

  ngOnInit(): void {
    this.globalState.isArcoprime$.subscribe((v) => (this.isArcoprime = v));

    this.globalState.pagadoresActivos$.subscribe((pagadores) => {
      if (!this.isArcoprime) return;
      this.pagadores = pagadores || [];
      if (this.pagadores.length === 1) {
        this.onPagadorChange(this.pagadores[0].id_pagador);
      }
    });

    this.globalState.allEds$.subscribe((eds) => {
      if (this.isArcoprime) return;
      this.edsOptions = eds || [];
      if (this.edsOptions.length === 1) {
        this.selectedEstacion = this.edsOptions[0]?.value;
        this.selectedEstacionComplete = this.edsOptions[0];
      }
    });

    // Cargar categoria Siniestro al inicializar
    this.api.getCategorias('Siniestro').subscribe({
      next: (data) => {
        const allSiniestros: { [key: string]: any } = {};

        data.forEach((siniestro: Record<string, any>) => {
          const keys = Object.keys(siniestro);
          allSiniestros[keys[0]] = siniestro[keys[0]];
        });

        this.allSiniestros = allSiniestros;
        const activeSiniestros: any[] = [];

        this.SINIESTROS.forEach(function (s) {
          if (allSiniestros[s.key] && allSiniestros[s.key].active)
            activeSiniestros.push(s);
        });

        this.activeSiniestros = activeSiniestros;
      },
      error: (err) => {
        console.error('Error cargando categoria Siniestro', err);
      },
    });
  }

  onEstacionChange(estacionValue: number): void {
    this.selectedEstacion = estacionValue;
    this.selectedEstacionComplete =
      this.edsOptions.find((eds) => eds.value === estacionValue) || null;
  }

  onPagadorChange(idPagador: string): void {
    this.selectedPagador = idPagador;
    this.selectedEstacion = null;
    this.selectedEstacionComplete = null;
    this.edsOptions = [];
    if (!idPagador) return;
    this.globalState.pagador = idPagador;
    this.externalApis.getEdsForPagador(idPagador, false).subscribe((eds) => {
      this.edsOptions = eds || [];
      if (this.edsOptions.length === 1) {
        this.selectedEstacion = this.edsOptions[0]?.value;
        this.selectedEstacionComplete = this.edsOptions[0];
      }
    });
  }

  siniestroClicked(siniestro: any): void {
    if (this.selectedEstacion === null) return;

    const newSelectedSiniestro = this.allSiniestros[siniestro.key];
    newSelectedSiniestro.key = siniestro.key;
    newSelectedSiniestro.label = siniestro.label;

    this.selectedSiniestro = newSelectedSiniestro;
    this.showFormulario = true;
  }

  closeFormulario(): void {
    this.selectedSiniestro = null;
    this.showFormulario = false;
  }

  finish(ncaso: string): void {
    this.showFormulario = false;
  }
}
